import { FC, useEffect, useRef, useState } from "react";
import Calculator from "@/modules/Calculator/Calculator";
import Borrower from "@/modules/Borrower/Borrower";
import * as Sentry from "@sentry/nextjs";
import Otp from "@/modules/Otp/Otp";
import Reject from "@/modules/Reject/Reject";
import { useAppInfoWithReject } from "@/hooks/useAppInfoWithReject";
import { useDispatch, useSelector } from "react-redux";
import {
  setUser,
  setResponseInfo,
  setResponseId,
  setCreditInfo,
  setOrderNumber,
  setIncomeVerification,
} from "@/store/slices/userSlice";
import { useRouter } from "next/router";
import Methods from "@/modules/methods/Methods";
import LoadingModal from "@/modules/modal/LoadingModal";
import BlockWithFileUpload from "@/modules/methods/components/BlockWithFileUpload";
import ContinueModal from "@/modules/methods/components/ContinueModal";
import CheckUpSuccessModal from "@/modules/modal/CheckUpSuccess";
import axios from "axios";
import { CancelService } from "@/api/service/CancelService";
import { sendEventToAmplitude } from "@/utils/sendEventToAmplitude";
import { links, UPLOAD_INCOME_DOCS_HASH } from "@/constans/links";
import { useReject } from "@/hooks/useReject";
import { ApiService, useSendErrorMessage } from "@/api/service/ApiService";
import BiometryModal from "@/modules/modal/BiometryModal";
import { useDeviceContext } from "@/context/deviceContext/deviceContext";
import { setIsUploadDocs } from "@/store/slices/uploadDocsSlice";
import { pushToDataLayer } from "@/utils/gtm";
import { setIsCloudEcp, setSignEcp } from "@/store/slices/digitalEcpSlice";
import { closeBiometry } from "@/store/slices/biometryModalSlice";
import UDVOtp from "@/modules/Otp/UDVOtp";

interface ITotal {
  sum: string;
  rate: string;
  term: string;
}

interface IncomeViewType {
  id: number;
  content: [
    {
      docType: string;
      docName: string;
    },
  ];
}

var authKey =
  "ef4c105f3cad489c926f560ed952f9c919d415342bc9487891c1951fd89864cc";
var url = "https://scoring.credolab.com";

function generateCredoLabId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const SMECredits: FC<{}> = ({}) => {
  const [total, settotal] = useState<ITotal>({ sum: "", rate: "", term: "" });
  const [open, setOpen] = useState(false);
  const [prod, setProd] = useState({ id: "" });
  const [phine, setPhine] = useState("");
  const [iin, setIIN] = useState("");
  const [openReject, setOpenReject] = useState(false);
  const { isMobile } = useDeviceContext();
  const { cancelTask } = CancelService();
  const { setRejectOpen, setInfoKey } = useReject();
  const { api } = ApiService();
  const { responseInfo } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const router = useRouter();
  const { isUploadDocs } = useSelector((state: any) => state.uploadDocs);
  const isIncomeDocsStep = router.asPath.includes(UPLOAD_INCOME_DOCS_HASH);
  const hasCredentials =
    router.asPath.includes("withCredentials") || isIncomeDocsStep;
  const [btnClicked, setBtnClicked] = useState(false);
  const [openUdv, setOpenUdv] = useState(false);

  const handleUTM = async ({ iin, mobile, email, businesskey }) => {
    try {
      const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } =
        router.query;
      if (utm_source || utm_medium || utm_campaign || utm_term || utm_content) {
        await api.post(`${process.env.NEXT_PUBLIC_BASE_URL}/application/utm`, {
          iin,
          mobile,
          email,
          businesskey,
          utmSource: utm_source || "",
          utmMedium: utm_medium || "",
          utmCampaign: utm_campaign || "",
          utmTerm: utm_term || "",
          utmContent: utm_content || "",
        });
      }
      return;
    } catch (e) {
      setInfoKey("7");
      setRejectOpen(true);
      throw e;
    }
  };

  const [credoAppService, setCredoAppService] = useState<any>(null);
  const credoLabIdRef = useRef<string>("");

  useEffect(() => {
    if (!credoLabIdRef.current) {
      credoLabIdRef.current = generateCredoLabId();
    }
    import("@credolab/credoapp-sdk").then((module) => {
      const { CredoAppServiceAsync } = module;
      const service = new CredoAppServiceAsync(url, authKey);
      setCredoAppService(service);
      service.startTrackingAsync(credoLabIdRef.current).then(
        () => {
          console.log("Event tracking started");
        },
        (e) => {
          console.log(e);
        }
      );
    });
    dispatch(closeBiometry());
  }, []);

  function stopTracking() {
    credoAppService.stopTrackingAsync().then(
      () => {
        alert("Event tracking stopped");
      },
      (e) => alert(e)
    );
  }

  function collectData() {
    if (!credoAppService) return;
    credoAppService.stopTrackingAndCompleteAsync().then(
      () => {
        console.log("Dataset has been completed");
      },
      (e) => {
        console.log(e);
      }
    );
  }

  const sendUserData = async ({
    iin,
    phone,
    email,
    date,
    branch,
    activeTask,
    contacts = [],
  }) => {
    try {
      setBtnClicked(true);
      if (activeTask) {
        localStorage.setItem("token", activeTask.token);
        await cancelTask();
        setIsContinueTask(false);
      }
      dispatch(
        setUser({
          iin: iin,
          mobile: `+7${phone}`,
          email: email,
          registrationDate: date,
          branch: branch || "",
          incomeVerification: income,
          phone: phone,
        }),
      );
      dispatch(setIncomeVerification(income));
      dispatch(setSignEcp(false));
      dispatch(setIsCloudEcp(false));

      const { data } = await axios.post(
        `${process.env.NEXT_PUBLIC_BASE_URL}/application/growing-business`,
        {
          clientInfo: {
            iin: iin,
            mobile: `+7${phone}`,
            email: email,
            registrationDate: date,
            branch: branch || "",
          },
          partnerInfo: {
            bin: "980640000093",
          },
          credolabId: credoLabIdRef.current,
          creditInfo: {
            amount: total?.sum || "",
            term: total?.term || "",
            currency: "KZT",
            rate: total?.rate || "",
          },
          incomeVerification: income,
          contacts: contacts,
        },
        {
          headers: {
            "X-User-ID": `+7${phone}`,
          },
        },
      );
      if (data) {
        setBtnClicked(false);
      }
      collectData();
      localStorage.setItem("token", data.token);
      setProd(data);

      setIIN(iin);

      dispatch(
        setCreditInfo({
          amount: total?.sum || "",
          term: total?.term || "",
          currency: "KZT",
          rate: total?.rate || "",
        }),
      );
      dispatch(setResponseInfo(data));
      dispatch(setResponseId(data?.id));
      dispatch(setOrderNumber(data?.orderNumber));
      sessionStorage.setItem("orderNumber", data?.orderNumber);
      setPhine(`+7${phone}`);
      sessionStorage.setItem("orderNumber", data?.orderNumber);
      dispatch(setOrderNumber(data?.orderNumber));
      await handleUTM({
        iin,
        mobile: `+7${phone}`,
        email,
        businesskey: data.orderNumber,
      });
      pushToDataLayer("growing_business_loan_form_apply");

      sendEventToAmplitude(
        `online_credit_form_page_${income ? "with_income" : "without_income"}`,
        {
          loan_credit: `${total?.sum} тг`,
          period: `${total?.term} month`,
          flow: income ? "с подтверждением дохода" : "без подтверждения дохода",
        },
      );

      return data;
    } catch (e: any) {
      const errorMessage = e?.response?.data?.message || "";
      const isEmailError = errorMessage.includes("/clientInfo/email");
      if (isEmailError) {
        setErrorText({
          group: "Ошибка в данных",
          reason:
            "Указан некорректный формат Email. Пожалуйста, проверьте адрес и попробуйте снова.",
        });
      } else {
        setInfoKey("7");
      }

      setOpenReject(true);
      setBtnClicked(false);

      useSendErrorMessage({
        errorUrl: e?.response?.config?.url,
        status: e?.response?.status,
        messageError: e?.message,
        businessKey: "",
        iin,
        username: `+7${phone}`,
        baseUrl: "",
      });

      Sentry.captureException(e);
      throw e;
    }
  };

  const [isContinueTask, setIsContinueTask] = useState(false);

  const continueTask = async ({
    iin,
    phone,
    email,
    date,
    branch,
    activeTask,
    contacts = [],
  }) => {
    try {
      setIsContinueTask(true);
      dispatch(
        setUser({
          iin: iin,
          mobile: `+7${phone}`,
          email: email,
          registrationDate: date,
          branch: branch || "",
          incomeVerification: activeTask?.incomeVerification,
          phone: phone,
        }),
      );
      dispatch(setIncomeVerification(activeTask?.incomeVerification));
      dispatch(setResponseInfo(activeTask));
      dispatch(setResponseId(activeTask?.id));
      dispatch(setOrderNumber(activeTask?.orderNumber));
      sessionStorage.setItem("orderNumber", activeTask?.orderNumber);
      localStorage.setItem("token", activeTask?.token);
      setPhine(`+7${phone}`);
      sessionStorage.setItem("orderNumber", activeTask?.orderNumber);
      dispatch(setOrderNumber(activeTask?.orderNumber));
      setIIN(iin);
      setProd(activeTask);
      dispatch(setSignEcp(false));
      dispatch(setIsCloudEcp(activeTask?.signType === "EDS"));

      collectData();

      try {
        await axios.post(
          `${process.env.NEXT_PUBLIC_BASE_URL}/application/credolab`,
          {
            credoLabId: credoLabIdRef.current,
            iin,
            businessKey: activeTask?.orderNumber,
            stage: activeTask?.eventName,
          },
          {
            headers: {
              "X-Token-Authorization": activeTask?.token,
            },
          },
        );
      } catch (e) {
        console.log("credolab continue tracking error", e);
      }

      if (activeTask.eventName === "VERIFICATION") {
        if (activeTask.processingEventStatus === "PROCESSED") {
          setErrorText({
            group: "Банк принимает решение",
            reason:
              "Ваша заявка находится в обработке, вернитесь к заявке чуть позже",
          });
          setOpenReject(true);
          return;
        }
        if (activeTask.processInfo.stageName.ru.includes("удостоверения")) {
          setOpenUdv(true);
        } else {
          setOpen(true);
        }

        const { data } = await api.get(
          `/application/growing-business/verification-info`,
        );
        sendEventToAmplitude("online_credit_otp_request_click", {
          loan_credit: `${total?.sum} тг`,
          period: `${total?.term} month`,
          flow: income ? "с подтверждением дохода" : "без подтверждения дохода",
        });
        return;
      }
      if (activeTask.eventName === "RETRY") {
        dispatch(
          setUser({
            iin: iin,
            mobile: `+7${phone}`,
            email: email,
            registrationDate: date,
            branch: branch || "",
            incomeVerification: activeTask?.incomeVerification,
            phone: phone,
          }),
        );
        dispatch(setIncomeVerification(activeTask?.incomeVerification));
        const { data } = await api.post(`/application/growing-business/retry`);
        if (data) {
          const res = await getAppInfo();
          if (res === "Biometry Start") {
            if (isMobile) router.push(`${links.BIOMETRIC}`);
            else {
              setLoading(false);
              setBiometryModal(true);
            }
          }
        }
        return;
      }
      if (activeTask.eventName === "INCOME_VERIFICATION") {
        dispatch(
          setUser({
            iin: iin,
            mobile: `+7${phone}`,
            email: email,
            registrationDate: date,
            branch: branch || "",
            incomeVerification: activeTask?.incomeVerification,
            phone: phone,
          }),
        );
        dispatch(setIncomeVerification(activeTask?.incomeVerification));
        if (activeTask.processingEventStatus === "PROCESSED") {
          router.push(`${links.SCORING_RESULTS}`);
          return;
        }
        setOpenBlockWithDoc(true);
        goToUploadRef();
        return;
      }
      if (
        activeTask.eventName === "SCORING_RESULTS" ||
        activeTask.eventName === "CREDIT_ISSUED"
      ) {
        dispatch(
          setUser({
            iin: iin,
            mobile: `+7${phone}`,
            email: email,
            registrationDate: date,
            branch: branch || "",
            incomeVerification: activeTask?.incomeVerification,
            phone: phone,
          }),
        );
        dispatch(setIncomeVerification(activeTask?.incomeVerification));
      }
      if (activeTask.eventName === "IN_PROGRESS") {
        setErrorText({
          group: "Банк принимает решение",
          reason:
            "Ваша заявка находится в обработке, вернитесь к заявке чуть позже",
        });
        setOpenReject(true);

        return;
      }
      if (
        activeTask.eventName === "SIGN_DOCS" &&
        activeTask.processInfo.stageName.ru.includes("согласия")
      ) {
        router.push("/kgd-docs");
        return;
      }
      router.push(links[activeTask.eventName]);
    } catch (e: any) {
      setInfoKey("7");
      setRejectOpen(true);
      throw e;
    }
  };

  const { errorText, getAppInfo, appInfo, setErrorText } = useAppInfoWithReject(
    {
      setOpenRejectModal: setOpenReject,
    },
  );

  useEffect(() => {
    console.log("V 1.0");
    if (
      appInfo.processingEventStatus === "UNPROCESSED" &&
      appInfo.eventName === "VERIFICATION"
    ) {
      (async () => {
        if (appInfo.processInfo.stageName.ru.includes("удостоверения")) {
          setOpenUdv(true);
        } else {
          setOpen(true);
        }
        setLoading(false);
        const { data } = await api.get(
          `/application/growing-business/verification-info`,
        );
        sendEventToAmplitude("online_credit_otp_request_click", {
          loan_credit: `${total?.sum} тг`,
          period: `${total?.term} month`,
          flow: income ? "с подтверждением дохода" : "без подтверждения дохода",
        });
      })();
    }
    if (
      appInfo.processingEventStatus === "PROCESSED" &&
      appInfo.eventName === "BANK_REJECTED"
    ) {
      setOpen(false);
      setLoading(false);
    }
    if (
      appInfo.processingEventStatus === "UNPROCESSED" &&
      appInfo.eventName === "SCORING_RESULTS"
    ) {
      router.push(`${links.SCORING_RESULTS}`);
    }

    if (
      appInfo.processingEventStatus === "UNPROCESSED" &&
      appInfo.eventName === "INCOME_VERIFICATION"
    ) {
      setLoading(false);
      setOpenCheckUpModal(true);
      sendEventToAmplitude("online_credit_hard_checks_success", {
        flow: income ? "с подтверждением дохода" : "без подтверждения дохода",
      });
    }
    if (
      appInfo.eventName === "SIGN_DOCS" &&
      appInfo.processInfo.stageName.ru.includes("согласия")
    ) {
      router.push("/kgd-docs");
      return;
    }
    if (
      appInfo.eventName === "SIGN_DOCS" &&
      appInfo.processingEventStatus === "UNPROCESSED"
    ) {
      router.push("/docs");
    }
    if (appInfo.eventName === "RETRY") {
      (async () => {
        const { data } = await api.post(`/application/growing-business/retry`);
        if (data) {
          await getAppInfo();
        }
      })();
    }
  }, [appInfo.eventName, appInfo.processInfo?.stageName?.ru]);

  const otpInfo = async () => {
    try {
      setIsContinueTask(false);
      setOpen(true);
      await getAppInfo();
    } catch (e) {
      throw e;
    }
  };

  const checkStatusVerifyOtp = async () => {
    try {
      setLoading(true);
      await getAppInfo();
    } catch (e) {
      throw e;
    }
  };

  useEffect(() => {
    if (prod.id && !isContinueTask) {
      checkStatusVerifyOtp();
    }
  }, [prod, isContinueTask]);

  const [biometryModal, setBiometryModal] = useState(false);

  const goToPage = async () => {
    try {
      setLoading(true);

      const result = await getAppInfo();
      if (result === "Biometry Start") {
        if (isMobile) router.push(`${links.BIOMETRIC}`);
        else {
          setLoading(false);
          setBiometryModal(true);
        }
      }
    } catch (e) {
      setBiometryModal(false);
      throw e;
    }
  };

  const nextBiometry = async () => {
    try {
      setLoading(true);

      const fetchAppInfo = async () => {
        const result = await getAppInfo();
        return result;
      };

      let intervalId;

      const checkStatusAndFetch = async () => {
        const result = await fetchAppInfo();

        if (result !== "Biometry Start") {
          setLoading(false);
          clearInterval(intervalId);
        }
      };

      intervalId = setInterval(checkStatusAndFetch, 5000);

      await checkStatusAndFetch();
    } catch (e) {
      setBiometryModal(false);
      throw e;
    }
  };

  const [loading, setLoading] = useState(false);

  // Клиент вернулся на главную уже на шаге INCOME_VERIFICATION (после согласия КГД):
  // заявка создана раньше, поэтому подтягиваем её статус, чтобы открылся блок загрузки
  // выписок, а не пустая форма заявки.
  const [isIncomeDocsRestored, setIsIncomeDocsRestored] = useState(false);
  useEffect(() => {
    if (!router.isReady || !isIncomeDocsStep || isIncomeDocsRestored) return;
    setIsIncomeDocsRestored(true);
    (async () => {
      try {
        setLoading(true);
        await getAppInfo();
      } finally {
        setLoading(false);
      }
    })();
  }, [router.isReady, isIncomeDocsStep, isIncomeDocsRestored]);

  const [income, setIncome] = useState(true);
  const [openCheckUpModal, setOpenCheckUpModal] = useState(false);
  const [openBlockWithDoc, setOpenBlockWithDoc] = useState(false);
  const [openContinueModal, setOpenContinueModal] = useState(false);
  const [incomeView, setIncomeView] = useState<IncomeViewType>({
    id: 0,
    content: [
      {
        docType: "",
        docName: "",
      },
    ],
  });
  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const getIncomeView = async () => {
    try {
      const { data } = await api.get(
        `/application/growing-business/verification-docs/views/income-view`,
      );
      setIncomeView(data);

      return data;
    } catch (e) {
      throw e;
    }
  };

  const getUploadedFiles = async (id = null) => {
    try {
      const { data } = await api.get(
        `/application/growing-business/verification-docs/views/${
          id || incomeView.id
        }/docs-info`,
      );

      if (data) {
        setUploadedFiles(data);
      }
    } catch (e: any) {
      if (e.response.status === 404) {
        setUploadedFiles([]);
        return;
      }
      throw e;
    }
  };

  const verifyIncome = async () => {
    try {
      const { data } = await api.post(
        `application/growing-business/verify-income`,
      );

      return data;
    } catch (e) {
      throw e;
    }
  };

  const ref = useRef<null | HTMLDivElement>(null);
  const handleClickToRef = () => {
    ref.current?.scrollIntoView({ block: "center", behavior: "smooth" });
  };

  const [isLoaderTimeOut, setIsLoaderTimeOut] = useState(false);

  const showError = (isTimeOut: boolean) => {
    setIsLoaderTimeOut(isTimeOut);
    setOpenReject(true);
    setLoading(false);
  };

  const { isOpen: biometryOpen } = useSelector((state: any) => state.biometry);
  useEffect(() => {
    if (biometryOpen === true) nextBiometry();
  }, [biometryOpen]);

  const uploadRef = useRef<null | HTMLDivElement>(null);
  const goToUploadRef = () => {
    uploadRef.current?.scrollIntoView({ block: "start", behavior: "smooth" });
  };

  return (
    <>
      {biometryModal && (
        <BiometryModal
          setBiometryVisible={setBiometryModal}
          biometryVisible={biometryModal}
        />
      )}
      <Calculator
        setTotal={settotal}
        hasCredentials={hasCredentials || isUploadDocs}
      />
      <Methods setIncome={setIncome} income={income} />
      <div ref={uploadRef}></div>
      {openBlockWithDoc && (
        <BlockWithFileUpload
          getIncomeView={getIncomeView}
          incomeView={incomeView}
          getUploadedFiles={getUploadedFiles}
          uploadedFiles={uploadedFiles}
          verifyIncome={async () => {
            if (uploadedFiles.length === 0) {
              setOpenContinueModal(true);
              return;
            }
            const res = await verifyIncome();
            if (res) {
              sendEventToAmplitude("online_credit_get_decision_click", {
                flow: income
                  ? "с подтверждением дохода"
                  : "без подтверждения дохода",
              });
              router.push(`${links.SCORING_RESULTS}`);
            }
          }}
        />
      )}
      {!openBlockWithDoc && (
        <Borrower
          sendUserData={sendUserData}
          continueTask={continueTask}
          hasCredentials={hasCredentials}
          btnClicked={btnClicked}
          setBiometryModal={setBiometryModal}
        />
      )}
      {openContinueModal && (
        <ContinueModal
          open={openContinueModal}
          handleContinue={async () => {
            setOpenContinueModal(false);
            dispatch(setIncomeVerification(false));
            const res = await verifyIncome();
            if (res) {
              setLoading(true);
              sendEventToAmplitude(`online_credit_continue_wo_income_click}`, {
                loan_credit: `${total?.sum} тг`,
                period: `${total?.term} month`,
                flow: "без подтверждения дохода",
              });

              await getAppInfo();
            }
          }}
          handleUpload={() => {
            setOpenContinueModal(false);
            handleClickToRef();
          }}
          handleClose={() => setOpenContinueModal(false)}
        />
      )}
      {openCheckUpModal && (
        <CheckUpSuccessModal
          open={openCheckUpModal}
          onClick={() => {
            dispatch(setIsUploadDocs(true));
            setOpenCheckUpModal(false);
            setOpenBlockWithDoc(true);
            goToUploadRef();
            pushToDataLayer("online_credit_ip_status_confirm");
            sendEventToAmplitude("online_credit_attach_docs_click", {
              flow: income
                ? "с подтверждением дохода"
                : "без подтверждения дохода",
            });
          }}
        />
      )}
      {open && (
        <Otp
          open={open}
          setOpen={setOpen}
          phone={phine}
          goToPage={goToPage}
          setOpenReject={setOpenReject}
          timeOut={60}
        />
      )}
      {openUdv && (
        <UDVOtp
          open={openUdv}
          setOpen={setOpenUdv}
          phone={phine}
          goToPage={goToPage}
          setOpenReject={setOpenReject}
          timeOut={60}
        />
      )}
      {openReject && (
        <Reject
          open={openReject}
          setOpen={setOpenReject}
          errortext={errorText}
          isTextFromApi={!isLoaderTimeOut}
          infoKey="6"
          iconType={isLoaderTimeOut ? "warning" : "reject"}
        />
      )}
      {loading && (
        <LoadingModal
          open={loading}
          setOpen={setLoading}
          showError={showError}
        />
      )}
    </>
  );
};

export default SMECredits;
